import React, { useState } from "react";
import { Step, StepLabel, Stepper, Typography } from "@material-ui/core";
import UploadFile from "./UploadFile";
import { connect } from "react-redux";
import ActiveStep from "./SvgIcons/ActiveStep";
import NonActiveStep from "./SvgIcons/NonActiveStep";
import { activeStepSelector } from "../reducers/controlReducer";
import LanguagePicker from "./LanguagePicker";
import TranslateFile from "./TranslateFile";
import DownloadFile from "./DownloadFile";

const LinearStepper = (props) => {
  function getSteps() {
    return ["Upload file", "Choose languages", "Translate file", "Download file"];
  }

  function getStepContent() {
    switch (props.step) {
      case 0:
        return <UploadFile />;
      case 1:
        return <LanguagePicker />;
      case 2:
        return <TranslateFile />;
      case 3:
        return <DownloadFile />;
      default:
        return null;
    }
  }

  const steps = getSteps();

  return (
    <div>
      <Stepper activeStep={props.step} orientation="horizontal">
        {steps.map((step, index) => {
          return (
            <Step key={index}>
              <StepLabel StepIconComponent={props.step === index ? ActiveStep : NonActiveStep}>{step}</StepLabel>
              {/* //currentStep === index ? StepperActive : StepperNotActice */}
            </Step>
          );
        })}
      </Stepper>
      <Typography component={"span"}>{getStepContent(props.step)}</Typography>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    langId: (langId) => dispatch(langId(langId))
  };
};

const mapStateToProps = (state) => {
  return {
    step: activeStepSelector(state)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LinearStepper);
